import { render, staticRenderFns } from "./ColouredBubbleEffect.vue?vue&type=template&id=b44db712&scoped=true"
import script from "./ColouredBubbleEffect.vue?vue&type=script&lang=js"
export * from "./ColouredBubbleEffect.vue?vue&type=script&lang=js"
import style0 from "./ColouredBubbleEffect.vue?vue&type=style&index=0&id=b44db712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44db712",
  null
  
)

export default component.exports